import { Transaction } from '../Types/Money';
import { RewardType } from '../Types/RewardType';
import { UserLootBox } from '../Types/UserLootBox';
import { UserReward } from '../Types/UserReward';
import { getApiInstance } from './Api';

export function mapUserLootBox(userLootBox: any): UserLootBox {
  return {
    type: userLootBox.type,
    rewards: userLootBox.rewards.map(mapUserReward),
  };
}

export const mapUserReward = (reward: any): UserReward => ({
  id: reward.id,
  rewardType: reward.rewardType,
  rewardData: reward.rewardData,
  createdAt: reward.createdAt && new Date(Date.parse(reward.createdAt)),
  spentAt: reward.spentAt && new Date(Date.parse(reward.spentAt)),
});

export class RewardsApi {
  async getUnspentRewards(rewardType?: RewardType): Promise<UserReward[]> {
    const response = await getApiInstance().get(
      `/rewards/unspent${rewardType ? `/${rewardType}` : ''}`,
    );
    return response.data.map(mapUserReward);
  }

  async getRewardsByEventKey(eventKey: string): Promise<Transaction[]> {
    const response = await getApiInstance().get(`/rewards/events/${eventKey}`);
    const data = response.data;
    return data;
  }
}
